import { UniqueIdol } from '../types';

export const UNIQUE_IDOLS: UniqueIdol[] = [
  {
    id: 'arbitrary-tenets',
    name: 'Arbitrary Tenets',
    description: [
      'Favours at Ritual Altars in your Maps randomly cost between 90% less and 80% more'
    ],
    fixedModifiers: [
      { modId: 1001, defaultValue: 0 }
    ]
  },
  {
    id: 'black-thumb',
    name: 'Black Thumb',
    description: [
      'Your Maps have no chance to contain the Sacred Grove',
      'Scarabs found in your Maps cannot be Harvest Scarabs',
      'Your Maps have +5% chance to contain other Extra Content that can be turned off through Atlas Passives'
    ],
    fixedModifiers: [
      { modId: 1002, defaultValue: 0 },
      { modId: 1003, defaultValue: 0 },
      { modId: 1004, defaultValue: 0 }
    ]
  },
  {
    id: 'bold-undertakings',
    name: 'Bold Undertakings',
    description: [
      'Fortune Favours the Brave applies an additional random Option',
      '100% more cost of the Fortune Favours the Brave Map Crafting Option'
    ],
    fixedModifiers: [
      { modId: 1005, defaultValue: 0 },
      { modId: 1006, defaultValue: 0 }
    ]
  },
  {
    id: 'cassias-pride',
    name: 'Cassia\'s Pride',
    description: [
      'Blight Monsters in your Maps take (75-65)% less Damage from Players and their Minions',
      'Blight Towers and their Minions in your Maps deal (300-400)% more Damage'
    ],
    fixedValueModifiers: [
      { modId: 1007, range: [65, 75], defaultValue: 70 }, // Default mid-range value
      { modId: 1008, range: [300, 400], defaultValue: 350 } // Default mid-range value
    ]
  },
  {
    id: 'crop-rotation',
    name: 'Crop Rotation',
    description: [
      'Harvest Crops in your Maps contain only Tier 1 Plants',
      'Harvesting Crops in your Maps has a chance to upgrade the Tier of Plants of different colours'
    ],
    fixedModifiers: [
      { modId: 1009, defaultValue: 0 },
      { modId: 1010, defaultValue: 0 }
    ]
  },
  {
    id: 'crystallised-power',
    name: 'Crystallised Power',
    description: [
      'A Map Boss is granted a random Essence Modifier from any Imprisoned Monsters slain in your Maps'
    ],
    fixedModifiers: [
      { modId: 1011, defaultValue: 0 }
    ]
  },
  {
    id: 'dance-of-destruction',
    name: 'Dance of Destruction',
    description: [
      'Monsters in your Maps deal (20-25)% more Damage',
      'Monsters in your Maps have (30-25)% less Life'
    ],
    fixedValueModifiers: [
      { modId: 1012, range: [20, 25], defaultValue: 22 }, // Default mid-range value
      { modId: 1013, range: [25, 30], defaultValue: 27 }  // Default mid-range value
    ]
  },
  {
    id: 'destructive-play',
    name: 'Destructive Play',
    description: [
      'The Maven casts Up the Stakes, summoning 1 to 3 additional Atlas Bosses when Witnessing Map Bosses',
      'The number of additional Bosses summoned is higher if there are fewer monsters remaining in the Map',
      'Modifiers to the Final Map Boss in each Map also apply to these summoned Bosses'
    ],
    fixedModifiers: [
      { modId: 1014, defaultValue: 0 },
      { modId: 1015, defaultValue: 0 },
      { modId: 1016, defaultValue: 0 }
    ]
  },
  // {
  //   id: 'dimensional-barrier',
  //   name: 'Dimensional Barrier',
  //   description: [
  //     'Your Maps have no chance to contain Breaches',
  //     'Scarabs found in your Maps cannot be Breach Scarabs',
  //     'Your Maps have +5% chance to contain other Extra Content that can be turned off through Atlas Passives'
  //   ],
  //   fixedModifiers: [
  //     { modId: 1017, defaultValue: 0 },
  //     { modId: 1018, defaultValue: 0 },
  //     { modId: 1019, defaultValue: 0 }
  //   ]
  // },
  {
    id: 'eldritch-gaze',
    name: 'Eldritch Gaze',
    description: [
      'Eldritch Altars Influenced by The Eater of Worlds have an additional Downside',
      'Eldritch Altars Influenced by The Eater of Worlds have (50-60)% increased Effect of Upsides'
    ],
    fixedModifiers: [
      { modId: 1020, defaultValue: 0 },
    ],
    fixedValueModifiers: [
      { modId: 1021, range: [50, 60], defaultValue: 55 } // Default mid-range value
    ]
  },
  {
    id: 'endless-tide',
    name: 'Endless Tide',
    description: [
      'Beyond Portals in your Maps cannot spawn Unique Bosses',
      'Beyond Portals in your Maps have (50-40)% less Merging Radius'
    ],
    fixedModifiers: [
      { modId: 1022, defaultValue: 0 },
    ],
    fixedValueModifiers: [
      { modId: 1023, range: [40, 50], defaultValue: 45 } // Default mid-range value
    ]
  },
  {
    id: 'extreme-archaeology',
    name: 'Extreme Archaeology',
    description: [
      'Number of Explosives is one',
      '(200-250)% increased Explosive Radius in your Maps',
      'Expedition Monsters in your Maps spawn with an additional (10-15)% of Life missing',
      '(100-150)% increased Explosive Placement Range in your Maps'
    ],
    fixedModifiers: [
      { modId: 1024, defaultValue: 0 },
    ],
    fixedValueModifiers: [
      { modId: 1025, range: [200, 250], defaultValue: 225 }, // Default mid-range value
      { modId: 1026, range: [10, 15], defaultValue: 12 }, // Default mid-range value
      { modId: 1027, range: [100, 150], defaultValue: 125 } // Default mid-range value
    ]
  },
  {
    id: 'fungal-remission',
    name: 'Fungal Remission',
    description: [
      'Your Maps have no chance to contain Blight Encounters',
      'Scarabs found in your Maps cannot be Blight Scarabs',
      'Your Maps have +5% chance to contain other Extra Content that can be turned off through Atlas Passives'
    ],
    fixedModifiers: [
      { modId: 1028, defaultValue: 0 },
      { modId: 1029, defaultValue: 0 },
      { modId: 1030, defaultValue: 0 }
    ]
  },
  {
    id: 'gruelling-gauntlet',
    name: 'Gruelling Gauntlet',
    description: [
      'Ultimatum Encounters in your Maps last up to 13 Rounds',
      'Players cannot choose which Ultimatum Modifier is applied each Round',
      'Cannot have a Boss in the final Round'
    ],
    fixedModifiers: [
      { modId: 1031, defaultValue: 0 },
      { modId: 1032, defaultValue: 0 },
      { modId: 1033, defaultValue: 0 }
    ]
  },
  {
    id: 'immutable-dogma',
    name: 'Immutable Dogma',
    description: [
      'Cannot Reroll Favours at Ritual Altars in your Maps',
      'Monsters Sacrificed at Ritual Altars in your Maps grant (100-150)% more Tribute'
    ],
    fixedModifiers: [
      { modId: 1034, defaultValue: 0 },
    ],
    fixedValueModifiers: [
      { modId: 1035, range: [100, 150], defaultValue: 125 } // Default mid-range value
    ]
  },
  {
    id: 'loved-by-the-sun',
    name: 'Loved by the Sun',
    description: [
      'Your Maps have no chance to contain Abysses',
      'Scarabs found in your Maps cannot be Abyss Scarabs',
      'Your Maps have +5% chance to contain other Extra Content that can be turned off through Atlas Passives'
    ],
    fixedModifiers: [
      { modId: 1036, defaultValue: 0 },
      { modId: 1037, defaultValue: 0 },
      { modId: 1038, defaultValue: 0 }
    ]
  },
  {
    id: 'lucid-dreams',
    name: 'Lucid Dreams',
    description: [
      'Vaal Side Areas in your Maps are no longer Corrupted'
    ],
    fixedModifiers: [
      { modId: 1039, defaultValue: 0 }
    ]
  },
  {
    id: 'meticulous-appraiser',
    name: 'Meticulous Appraiser',
    description: [
      'Modifiers to Quantity of Items found in your Maps instead apply to Rarity of Items found in your Maps at 300% of their value'
    ],
    fixedModifiers: [
      { modId: 1040, defaultValue: 0 }
    ]
  },
  {
    id: 'ominous-silence',
    name: 'Ominous Silence',
    description: [
      'Your Maps have no chance to contain Mirrors of Delirium',
      'Scarabs found in your Maps cannot be Delirium Scarabs',
      'Your Maps have +5% chance to contain other Extra Content that can be turned off through Atlas Passives'
    ],
    fixedModifiers: [
      { modId: 1041, defaultValue: 0 },
      { modId: 1042, defaultValue: 0 },
      { modId: 1043, defaultValue: 0 }
    ]
  },
  {
    id: 'perceived-greatness',
    name: 'Perceived Greatness',
    description: [
      'Delirious Monsters Killed in your Maps provide (30-20)% reduced Reward Progress',
      'Delirium Reward Types in your Maps gain +1 to count on Map Completion'
    ],
    fixedModifiers: [
      { modId: 1045, defaultValue: 0 }
    ],
    fixedValueModifiers: [
      { modId: 1044, range: [-30, -20], defaultValue: -25 }, // Default mid-range value
    ]
  },
  {
    id: 'ruinous-wager',
    name: 'Ruinous Wager',
    description: [
      'Ultimatum Monsters in your Maps apply Ruin with their special abilities',
      'Fail on reaching 7 Ruin',
      'Ultimatum Monsters and Modifiers in your Maps deal (60-50)% less Damage'
    ],
    fixedModifiers: [
      { modId: 1046, defaultValue: 0 },
      { modId: 1047, defaultValue: 0 },
    ],
    fixedValueModifiers: [
      { modId: 1048, range: [50, 60], defaultValue: 55 } // Default mid-range value
    ]
  },
  {
    id: 'sealed-domain',
    name: 'Sealed Domain',
    description: [
      'Your Maps have no chance to contain Legion Encounters',
      'Scarabs found in your Maps cannot be Legion Scarabs',
      'Your Maps have +5% chance to contain other Extra Content that can be turned off through Atlas Passives'
    ],
    fixedModifiers: [
      { modId: 1049, defaultValue: 0 },
      { modId: 1050, defaultValue: 0 },
      { modId: 1051, defaultValue: 0 }
    ]
  },
  {
    id: 'secular-focus',
    name: 'Secular Focus',
    description: [
      'Your Maps have no chance to contain Ritual Altars',
      'Scarabs found in your Maps cannot be Ritual Scarabs',
      'Your Maps have +5% chance to contain other Extra Content that can be turned off through Atlas Passives'
    ],
    fixedModifiers: [
      { modId: 1052, defaultValue: 0 },
      { modId: 1053, defaultValue: 0 },
      { modId: 1054, defaultValue: 0 }
    ]
  },
  {
    id: 'servant-of-order',
    name: 'Servant of Order',
    description: [
      'Your Maps have no chance to contain Ultimatum Encounters',
      'Scarabs found in your Maps cannot be Ultimatum Scarabs',
      'Your Maps have +5% chance to contain other Extra Content that can be turned off through Atlas Passives'
    ],
    fixedModifiers: [
      { modId: 1055, defaultValue: 0 },
      { modId: 1056, defaultValue: 0 },
      { modId: 1057, defaultValue: 0 }
    ]
  },
  {
    id: 'shadow-shaping',
    name: 'Shadow Shaping',
    description: [
      'Maps found cannot be your Favoured Maps',
      'Maps found in your Maps have +1% chance to have a special Implicit Modifier for each different Map you have Favoured'
    ],
    fixedModifiers: [
      { modId: 1058, defaultValue: 0 },
      { modId: 1059, defaultValue: 0 }
    ]
  },
  {
    id: 'singular-focus',
    name: 'Singular Focus',
    description: [
      'Maps found have (200-220)% more chance to be Favoured Maps',
      'Non-Favoured Maps found in your Maps drop as Basic Currency Items instead'
    ],
    fixedModifiers: [
      { modId: 1061, defaultValue: 0 }
    ],
    fixedValueModifiers: [
      { modId: 1060, range: [200, 220], defaultValue: 210 } // Default mid-range value
    ]
  },
  {
    id: 'smash-and-grab',
    name: 'Smash and Grab',
    description: [
      'Each Legion in your Maps contains an additional War Hoard',
      'Legion Chests in your Maps contain an additional Random Reward',
      'Legion Encounters in your Maps have (80-60)% reduced Duration'
    ],
    fixedModifiers: [
      { modId: 1062, defaultValue: 0 },
      { modId: 1063, defaultValue: 0 },
    ],
    fixedValueModifiers: [
      { modId: 1064, range: [60, 80], defaultValue: 70 } // Default mid-range value
    ]
  },
  {
    id: 'speaker-of-the-dead',
    name: 'Speaker of the Dead',
    description: [
      'Tormented Spirits in your Maps can Possess Players for 20 seconds',
      'Tormented Spirits in your Maps cannot Possess Monsters'
    ],
    fixedModifiers: [
      { modId: 1065, defaultValue: 0 },
      { modId: 1066, defaultValue: 0 }
    ]
  },
  {
    id: 'straight-and-narrow',
    name: 'Straight and Narrow',
    description: [
      'Your Maps have no chance to contain Smuggler\'s Caches',
      'Rogue\'s Markers, Contracts and Blueprints cannot be found in Your Maps',
      'Your Maps have +5% chance to contain other Extra Content that can be turned off through Atlas Passives'
    ],
    fixedModifiers: [
      { modId: 1067, defaultValue: 0 },
      { modId: 1068, defaultValue: 0 },
      { modId: 1069, defaultValue: 0 }
    ]
  },
  {
    id: 'thorough-exploration',
    name: 'Thorough Exploration',
    description: [
      'If there are fewer than 50 monsters remaining in your Maps, Final Map Bosses are Empowered by Wildwood Wisps'
    ],
    fixedModifiers: [
      { modId: 1070, defaultValue: 0 }
    ]
  },
  {
    id: 'timeless-conflict',
    name: 'Timeless Conflict',
    description: [
      'Legion Encounters in your Maps have no Timer',
      'Breaking out Monsters and Chests that are in stasis progressively causes a Schism',
      'Legion Encounters in your Maps begin once the Schism has occurred'
    ],
    fixedModifiers: [
      { modId: 1071, defaultValue: 0 },
      { modId: 1072, defaultValue: 0 },
      { modId: 1073, defaultValue: 0 }
    ]
  },
  {
    id: 'trade-embargo',
    name: 'Trade Embargo',
    description: [
      'Your Maps have no chance to contain Expedition Encounters',
      'Scarabs found in your Maps cannot be Expedition Scarabs',
      'Your Maps have +5% chance to contain other Extra Content that can be turned off through Atlas Passives'
    ],
    fixedModifiers: [
      { modId: 1074, defaultValue: 0 },
      { modId: 1075, defaultValue: 0 },
      { modId: 1076, defaultValue: 0 }
    ]
  },
  {
    id: 'twist-of-fate',
    name: 'Twist of Fate',
    description: [
      'Your Corrupted Rare Maps and any Map Crafting options applying to them are modified unpredictably when opened',
      'Maps modified in this way have 1-3 additional random Map Modifiers'
    ],
    fixedModifiers: [
      { modId: 1077, defaultValue: 0 },
      { modId: 1078, defaultValue: 0 }
    ]
  },
  {
    id: 'twisted-wish',
    name: 'Twisted Wish',
    description: [
      'Ultimatum Modifiers in your Maps start a Tier higher if possible',
      'Ultimatum Encounters in your Maps get 3% reduced Radius each Round'
    ],
    isSpecial: true,
    fixedModifiers: [
      { modId: 1079, defaultValue: 0 },
      { modId: 1080, defaultValue: 0 }
    ],
    variableModifiers: [
      { modId: 1081, range: [80, 95], defaultValue: 85 },
      { modId: 1082, range: [80, 95], defaultValue: 85 },
      { modId: 1083, range: [80, 95], defaultValue: 85 },
      { modId: 1084, range: [80, 95], defaultValue: 85 },
      { modId: 1085, range: [80, 95], defaultValue: 85 },
      { modId: 1086, range: [80, 95], defaultValue: 85 },
      { modId: 1087, range: [80, 95], defaultValue: 85 },
      { modId: 1088, range: [80, 95], defaultValue: 85 },
      { modId: 1089, range: [80, 95], defaultValue: 85 },
      { modId: 1090, range: [80, 95], defaultValue: 85 },
      { modId: 1091, range: [80, 95], defaultValue: 85 },
      { modId: 1092, range: [80, 95], defaultValue: 85 },
      { modId: 1093, range: [80, 95], defaultValue: 85 },
      { modId: 1094, range: [80, 95], defaultValue: 85 },
      { modId: 1095, range: [80, 95], defaultValue: 85 },
      { modId: 1096, range: [80, 95], defaultValue: 85 },
      { modId: 1097, range: [80, 95], defaultValue: 85 }
    ],
    variableModifiersRequired: 3
  },
  {
    id: 'unending-nightmare',
    name: 'Unending Nightmare',
    description: [
      'Delirium Fog in your Maps never dissipates',
      'Delirium in your Maps has doubled difficulty scaling with distance from the mirror',
      'Simulacrum Splinters cannot be found in your Maps',
      'Delirium Orbs cannot be found in your Maps'
    ],
    fixedModifiers: [
      { modId: 1098, defaultValue: 0 },
      { modId: 1099, defaultValue: 0 },
      { modId: 1100, defaultValue: 0 },
      { modId: 1101, defaultValue: 0 }
    ]
  },
  {
    id: 'well-supplied',
    name: 'Well Supplied',
    description: [
      '(30-50)% increased Intelligence gained from Immortal Syndicate targets encountered in your Maps',
      'Syndicate Members Obtain an additional Equipment Item when appearing in your Maps',
      'Immortal Syndicate Leaders in your Maps drop an additional Veiled Item'
    ],
    fixedModifiers: [
      { modId: 1103, defaultValue: 0 },
      { modId: 1104, defaultValue: 0 }
    ],
    fixedValueModifiers: [
      { modId: 1102, range: [30, 50], defaultValue: 40 } // Default mid-range value
    ]
  },
  {
    id: 'wellspring-of-creation',
    name: 'Wellspring of Creation',
    description: [
      'Monsters in your Maps have (40-50)% more Life',
      'Monsters in your Maps deal (30-25)% less Damage'
    ],
    fixedValueModifiers: [
      { modId: 1105, range: [40, 50], defaultValue: 45 }, // Default mid-range value
      { modId: 1106, range: [25, 30], defaultValue: 27 }  // Default mid-range value
    ]
  },
  {
    id: 'wrath-of-the-cosmos',
    name: 'Wrath of the Cosmos',
    description: [
      'Eldritch Altars Influenced by The Searing Exarch which have an additional Upside have (80-100)% increased Effect of Downsides',
      'Eldritch Altars Influenced by The Searing Exarch have (50-60)% chance to have an additional Upside'
    ],
    fixedValueModifiers: [
      { modId: 1107, range: [80, 100], defaultValue: 90 }, // Default mid-range value
      { modId: 1108, range: [50, 60], defaultValue: 55 }  // Default mid-range value
    ]
  },
  {
    id: 'refiners-bragain',
    name: 'Refiner\'s Bargain',
    description: [
      'Equipment Items with Rarity dropped by Possessed Monsters in your Maps have 5% chance to be converted to Thaumaturgic Dust',
      'Sulphite found in your Maps is granted as a random Ore instead at 15% of the value',
      'Lifeforce found in your Maps is granted as a random Crop instead at 150% of the value'
    ],
    fixedValueModifiers: [
      { modId: 1109, range: [5, 5], defaultValue: 5 }, // Default mid-range value
      { modId: 1110, range: [15, 15], defaultValue: 15 },  // Default mid-range value
      { modId: 1111, range: [150, 150], defaultValue: 150 }  // Default mid-range value
    ]
  }

];

export default UNIQUE_IDOLS;